/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n(n){return{enabled:!(null==n||!n.length)}}export{n as writeNonEmptyCollectionPolicy};
